module.exports = __webpack_public_path__ + "media/images/chat_bg_dark-c997ec34089b06bce05648f913284dca.jpg";